import React from 'react';
import ComposedDatePicker from '@/pages/intelligence/components/ComposedDatePicker';
import { ComposedDateMode } from '@/pages/intelligence/components/ComposedDatePicker/enums';

import type { IBaseProps, IDateType, IDateValue } from '@/pages/intelligence/types/common';
import type { IComposedDateData } from '@/pages/intelligence/components/ComposedDatePicker/types';

import './index.scss';

interface IActionbarProps extends IBaseProps {
  disabled?: boolean;
  dateTypes?: IDateType[];
  rangePickerProps?: {};
  composedDateData: IComposedDateData;
  onComposedPickerChange?: (mode: ComposedDateMode, dateType: IDateType, dateValue: IDateValue) => void;
  downloadNodeRenderer?: () => React.ReactElement;
}

const Actionbar: React.FC<IActionbarProps> = (props) => {
  const {
    disabled = false,
    dateTypes,
    rangePickerProps,
    composedDateData,
    onComposedPickerChange,
    downloadNodeRenderer,
  } = props;

  return (
    <div className="dbi-compare__actionbar">
      <ComposedDatePicker
        disabled={disabled}
        dateTypes={dateTypes}
        rangePickerProps={rangePickerProps}
        mode={composedDateData?.mode}
        dateType={composedDateData?.dateType}
        dateValue={composedDateData?.dateValue}
        onChange={onComposedPickerChange}
      />
      {/* 下载按钮，组件外部自行控制渲染 和 下载的业务逻辑 */}
      {downloadNodeRenderer?.()}
    </div>
  );
};

export default Actionbar;
